import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItem } from './trendListResponsePageAllOfThreeContentItemContentTweetsItem';

/**
 * 트렌드 관련 콘텐츠
 */
export type TrendListResponsePageAllOfThreeContentItemContent = {
  tweets?: TrendListResponsePageAllOfThreeContentItemContentTweetsItem[];
};
